import { render, staticRenderFns } from "./CsTriggersV2.vue?vue&type=template&id=bc54b2ae&scoped=true&"
import script from "./CsTriggersV2.vue?vue&type=script&lang=js&"
export * from "./CsTriggersV2.vue?vue&type=script&lang=js&"
import style0 from "./CsTriggersV2.vue?vue&type=style&index=0&id=bc54b2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc54b2ae",
  null
  
)

export default component.exports